import React from 'react';

function Terms() {
  return (
    <main className="bg-white">
      <section className="pt-28 pb-14">
        <div className="max-w-4xl mx-auto px-6 space-y-12">
          <header>
            <h1 className="text-3xl sm:text-4xl font-semibold text-gray-900">Terms of Service</h1>
            <p className="mt-3 text-gray-600 max-w-2xl">Please read these Terms carefully. By accessing our sites or using our services you agree to be bound by them.</p>
          </header>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">1. Acceptance & Updates</h2>
            <p className="mt-3 text-gray-600">Your use constitutes acceptance of these Terms and related policies. We may update Terms periodically; continued use after publication indicates acceptance.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">2. Accounts & Security</h2>
            <p className="mt-3 text-gray-600">You are responsible for maintaining the confidentiality of credentials and for all activities under your account. Notify us immediately of any suspected unauthorized use.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">3. No Advice</h2>
            <p className="mt-3 text-gray-600">Content is for informational purposes only and does not constitute investment, legal, tax or accounting advice. Decisions should be based on your independent judgment and, where appropriate, professional advice.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">4. Eligibility & Compliance</h2>
            <p className="mt-3 text-gray-600">You represent that you have authority to use the services and will comply with applicable laws, including KYC/AML and sanctions regulations where relevant.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">5. Acceptable Use</h2>
            <ul className="mt-3 text-gray-700 space-y-2">
              <li className="flex gap-2"><span className="mt-1 w-2 h-2 bg-[#0056d7] rounded-full" /> No reverse engineering, scraping, penetration testing without authorization.</li>
              <li className="flex gap-2"><span className="mt-1 w-2 h-2 bg-[#0056d7] rounded-full" /> No misuse, fraud, harmful code, or infringement of third‑party rights.</li>
              <li className="flex gap-2"><span className="mt-1 w-2 h-2 bg-[#0056d7] rounded-full" /> Maintain confidentiality of credentials and device hygiene.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">6. Intellectual Property</h2>
            <p className="mt-3 text-gray-600">All content, trademarks and software are owned by us or our licensors and protected by applicable laws. No rights are granted except as expressly set out here.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">7. Third‑Party Services</h2>
            <p className="mt-3 text-gray-600">We may integrate with custodians, payment providers or data vendors. Their terms apply in addition to these Terms; we are not responsible for third‑party content or practices.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">8. Market Data & Content</h2>
            <p className="mt-3 text-gray-600">Any market data, research or commentary is provided “as is” and may be delayed or incorrect. Do not rely on it as the sole basis for decisions.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">9. Disclaimers</h2>
            <p className="mt-3 text-gray-600">Services are provided without warranties of any kind, express or implied, including fitness for a particular purpose and non‑infringement. We do not guarantee uninterrupted or error‑free operation.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">10. Limitation of Liability</h2>
            <p className="mt-3 text-gray-600">To the maximum extent permitted by law, we are not liable for indirect, incidental, special or consequential damages, or loss of profits, data or goodwill, arising from your use of the services.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">11. Indemnity</h2>
            <p className="mt-3 text-gray-600">You agree to indemnify and hold us harmless from claims arising out of your breach of these Terms or misuse of the services.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">12. Governing Law & Disputes</h2>
            <p className="mt-3 text-gray-600">These Terms are governed by applicable laws in our principal place of business, without regard to conflict‑of‑law rules. Disputes will be resolved through good‑faith negotiation and, failing that, arbitration or competent courts as permitted by law.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">13. Termination</h2>
            <p className="mt-3 text-gray-600">We may suspend or terminate access for suspected violations, unlawful activity or risk to the platform. You may stop using the services at any time; certain obligations survive termination.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">14. Changes</h2>
            <p className="mt-3 text-gray-600">We may update these Terms; material changes will be posted with an updated effective date below.</p>
            <p className="mt-1 text-gray-500 text-sm">Effective date: {new Date().toLocaleDateString()}</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">15. Force Majeure</h2>
            <p className="mt-3 text-gray-600">Neither party is liable for delays or failures due to events beyond reasonable control, including acts of God, war, strikes, failures of suppliers, or internet disruptions.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">16. Assignment</h2>
            <p className="mt-3 text-gray-600">You may not assign these Terms without our consent. We may assign to an affiliate or in connection with a merger, acquisition or sale of assets.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">17. Severability & Waiver</h2>
            <p className="mt-3 text-gray-600">If any provision is found unenforceable, the remaining provisions remain in effect. Failure to enforce is not a waiver.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">18. Entire Agreement</h2>
            <p className="mt-3 text-gray-600">These Terms, together with referenced policies, constitute the entire agreement and supersede prior understandings regarding the services.</p>
          </div>

          <div>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">19. Contact</h2>
            <p className="mt-3 text-gray-600">Questions: <a href="mailto:legal@blockfirstcapital.com" className="text-[#0056d7] hover:underline">legal@blockfirstcapital.com</a>.</p>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Terms;



